import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const tailwindUtils = {
  card: "border border-[var(--border-ultra-subtle)] bg-[var(--surface-primary)]",
  input: "flex h-10 w-full border border-[var(--border-medium)] bg-[var(--surface-primary)] px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-[var(--text-tertiary)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent-primary)] focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
  container: "mx-auto max-w-[var(--container-max-width)] px-[var(--container-padding)]",
  textPrimary: "text-[var(--text-primary)]",
  textSecondary: "text-[var(--text-secondary)]",
  textTertiary: "text-[var(--text-tertiary)]",
  surfacePrimary: "bg-[var(--surface-primary)]",
  surfaceSecondary: "bg-[var(--surface-secondary)]",
  surfaceHover: "bg-[var(--surface-hover)]",
} as const;
